export type AboutTabKey =
  | 'our-vision'
  | 'corporate-social-responsibility'
  | 'managements'
  | 'message-from-cmd'
  | 'quality-standards';

/** Strapi / gatsby-source-strapi-graphql uses underscores in enum values. */
export function normalizeAboutTabKey(tabKey: string): AboutTabKey {
  const normalized = tabKey.replace(/_/g, '-');
  if (normalized in ABOUT_TAB_PATHS) {
    return normalized as AboutTabKey;
  }
  return 'our-vision';
}

export type AboutSectionType =
  | 'hero'
  | 'split-sections'
  | 'quote-block'
  | 'leadership-section'
  | 'infrastructure-section'
  | 'rich-content'
  | 'media-block'
  | 'accordion-section'
  | 'profile-highlight';

export function normalizeAboutSectionType(
  sectionType: string,
): AboutSectionType {
  return sectionType.replace(/_/g, '-') as AboutSectionType;
}

export const ABOUT_TAB_PATHS: Record<AboutTabKey, string> = {
  'our-vision': '/about/',
  'corporate-social-responsibility': '/about/social-responsibility/',
  managements: '/about/managements/',
  'message-from-cmd': '/about/message-from-cmd/',
  'quality-standards': '/about/quality-standards-and-infrastructure/',
};

export function normalizeAboutPath(pathname: string): string {
  if (!pathname.startsWith('/about')) return pathname;
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed ? `${trimmed}/` : '/about/';
}

export function pathToAboutTabKey(pathname: string): AboutTabKey {
  const normalized = normalizeAboutPath(pathname);
  const entry = Object.entries(ABOUT_TAB_PATHS).find(
    ([, path]) => normalizeAboutPath(path) === normalized,
  );
  return (entry?.[0] as AboutTabKey | undefined) ?? 'our-vision';
}

export function aboutTabKeyToPath(tabKey: string): string {
  return ABOUT_TAB_PATHS[normalizeAboutTabKey(tabKey)];
}
